import { getRegisteredWebOrigins } from "@degaus/shared/brand-config";

const WONDA_DEFAULT_REDIRECT = "/account";

const ALLOWED_REDIRECT_HOSTS = new Set([
  // Registered product web origins (wonda.sh, www/staging, login.wonda.sh).
  ...getRegisteredWebOrigins().map((origin) => new URL(origin).hostname),
  // Legacy wondercat.ai hosts (redirect to wonda.sh upstream).
  "wondercat.ai",
  "www.wondercat.ai",
  "app.wondercat.ai",
  ...(import.meta.env.DEV ? ["localhost"] : []),
]);

export function getSafeCliRedirectUrl(url: string | undefined): string {
  if (!url) return WONDA_DEFAULT_REDIRECT;
  if (url.startsWith("/") && !url.startsWith("//")) return url;
  try {
    const parsed = new URL(url);
    if (ALLOWED_REDIRECT_HOSTS.has(parsed.hostname)) return url;
  } catch {
    // malformed — reject
  }
  return WONDA_DEFAULT_REDIRECT;
}
